import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Home, ChevronRight, Clock } from "lucide-react";
import api from "@/lib/api";
import { STEPS, currentStepIndex, statusBanner } from "@/lib/tracking";
import { PushToggle } from "@/components/PushToggle";
import { Button } from "@/components/ui/button";

function OrderCard({ order, onOpen }) {
  const step = currentStepIndex(order);
  const banner = statusBanner(order);
  return (
    <button data-testid={`active-order-${order.id}`} onClick={onOpen}
      className="w-full text-left glass rounded-2xl p-4 card-hover border border-amber-500/15">
      <div className="flex items-center justify-between">
        <span className="font-mono text-amber-400 font-bold">{order.order_number}</span>
        <span className="font-mono text-slate-200 text-sm flex items-center gap-1">{order.total.toFixed(2)} € <ChevronRight className="w-4 h-4 text-amber-400" /></span>
      </div>
      <p className="text-xs text-slate-400 mt-1 truncate">{order.items.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</p>
      <div className={`mt-3 rounded-xl border px-3 py-2 text-xs font-semibold ${banner.cls}`}>{banner.text}</div>
      <div className="flex gap-1 mt-3">
        {STEPS.map((s, i) => (
          <div key={s.key} className={`h-1.5 flex-1 rounded-full ${i <= step ? "bg-amber-500" : "bg-slate-700"}`} />
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-1">{STEPS[step].label}</p>
    </button>
  );
}

export default function MyOrders() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    let timer;
    const load = async () => {
      try {
        const { data } = await api.get("/orders/active");
        setOrders(data);
        if (data.length === 0) { navigate("/", { replace: true }); return; }
      } catch (e) {}
      timer = setTimeout(load, 5000);
    };
    load();
    return () => clearTimeout(timer);
  }, [navigate]);

  if (!orders) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 text-amber-400 animate-spin" /></div>;

  return (
    <div data-testid="my-orders-page" className="max-w-md mx-auto min-h-screen bg-[#08080C] border-x border-amber-500/10 px-6 py-8">
      <h1 className="text-3xl font-bold text-slate-100">Mes commandes <span className="gold-text">en cours</span></h1>
      <p className="text-[11px] text-slate-500 mt-2 flex items-center gap-1"><Clock className="w-3 h-3" /> Suivi en direct — mise à jour automatique.</p>
      <div className="mt-3"><PushToggle className="w-full justify-center py-3" /></div>
      <div className="mt-6 space-y-4">
        {orders.map((o) => <OrderCard key={o.id} order={o} onOpen={() => navigate(`/order/${o.id}`)} />)}
      </div>
      <Button data-testid="my-orders-back-catalog" variant="ghost" onClick={() => navigate("/", { state: { browse: true } })}
        className="w-full mt-6 text-slate-400 hover:text-amber-300">
        <Home className="w-4 h-4 mr-2" /> Retour au catalogue
      </Button>
    </div>
  );
}
